import { useState } from "react";
import { motion } from 'motion/react';
import Currency from '../utils/Currency.js';

export function UpsellProduct({ currency, locale, index, product, upsell, isSelected, highlight, price, onClick }) {
    const [animationExecuted, setAnimationExecuted] = useState(false);
    const animationDelay = 1;
    const animationDuration = 0.5;
    const animationRepeatDelay = 1;
    const animationRepeat = 5;

    const handleClick = () => {
        if (onClick) onClick(product);
    };

    return (
        <motion.div
            key={`upsell-${index}`}
            id={`upsell-product-${index}`}
            animate={highlight && !animationExecuted ? { x: [0, -20, 20, -20, 20, 0]} : { x: 0 }}
            transition={{x: { delay: animationDelay, duration: animationDuration, repeatDelay: animationRepeatDelay, repeat: animationRepeat }}}
            whileTap={{ scale: 0.9 }}
            whileHover={animationExecuted ? { scale: 1.03 } : {}}
            onAnimationComplete={() => setAnimationExecuted(true)}
            className="cursor-pointer"
        >
            <div className="space-y-4" onClick={handleClick}>
                <div className={`h-[138px] px-10 py-10 bg-upsell rounded-[30px] flex items-center border-solid border-[5px]${isSelected ? ' border-cat' : ' border-transparent'}`}>
                    <div className="w-full flex items-center justify-between">
                        <div className={`secondary-font-bold fs-30 lh-25`} style={{ color: isSelected ? 'unset' : 'var(--color-text-muted)' }}>
                        <span>{upsell.title}</span>
                        {upsell.description ? (
                            <>
                                <br/>
                                <span className="block mt-2 fs-20">{upsell.description}</span>
                            </>
                        ) : null}
                        </div>
                        {price && price > 0 ? (
                            <div className="w-auto flex items-center justify-end gap-4">
                                {upsell.tag ? (
                                    <div className="custom-tag fs-18 secondary-font-bold uppercase px-2 py-1 rounded-lg flex items-center">
                                        <div>{upsell.tag}</div>
                                    </div>
                                ) : null}
                                <div className="text-common-price fs-35 text-right">
                                    <span>
                                        {new Currency(currency, locale).format(price)}
                                    </span>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </motion.div>
    );
}